<template>
  <div id="bar-chart" class="echarts">
    <VueApexCharts 
      :type="args.type"
      :options="options"
      :series="series"
      :height="height"
    >
    </VueApexCharts>
        <h3 v-if="args.graphTitle != null"> {{args.graphTitle}}</h3>

  </div>
</template>

<script >
import VueApexCharts from 'vue-apexcharts'
import { sync } from 'vuex-pathify'
import ui from '@/../../coreui/helpers/ui'

export default {
  props: ['args'],
  components: {
    VueApexCharts
  },
  watch: {
    fullScreen(val) {
      var self = this
      let newOptions = Object.assign({}, this.options, {
        labels: this.args.labels == null ? [] : this.args.labels, 
        legend: {
          show: val ? true : this.args.stacked == true ? true : false
        },
        xaxis: {
            labels: {
              show: true,
              formatter: 
              this.fullScreen ? self.noTrim : self.shortTrim
            },
          }
        }
      )
      this.options = newOptions
      setTimeout(function() {
        if (val) self.height="98%"
        else self.height = "100%"
      },500)
      
    },
    args: {
      immediate: true,
      deep: true,
      handler (val, old) {
        this.series = val.values
        let newOptions = Object.assign({}, this.options, {
          labels: val.labels == null || val.labels == undefined ? [] : val.labels,
          xaxis: val.xaxis ? val.xaxis : []
          }
        )
        this.options = newOptions
      }
    },
    dark: {
      immediate: true,
      handler(val, old) {
        let newOptions = Object.assign({}, this.options, {
          chart: {
          background: this.args.flat ? ui.theme(this.dark).plainBackground : ui.theme(this.dark).lighterbg,
          stacked: this.args.stacked != undefined ? this.args.stacked : false,
          toolbar: { show: false}
        },
        theme: {
          mode : val ? 'dark' : 'light',
          palette: val ? this.args.palette_dark  :
          this.args.palette_light ,  
        },
        fill: this.args.stacked ? {opacity: 1} : this.gradientFill
        })
        this.options = newOptions
      }
    },
    
  },
  data () {
    return {
      gradientFill : {
        type: "gradient",
        gradient: {
          shade: "dark",
          type: "vertical",
          shadeIntensity: 0.5,
          inverseColors: false,
          opacityFrom: 1,
          opacityTo: 0.8,
          stops: [0, 100]
        }
      },
      height: "100%",
      options:  {
        chart: {
          background: this.args.flat ? ui.theme(this.dark).plainBackground : ui.theme(this.dark).lighterbg,
          stacked: this.args.stacked != undefined ? this.args.stacked : false,
          title:  'Hello', //this.args.graphSub  ? this.args.graphSub : '',
          animations: { 
            enabled: true, easing: "linear", speed: 15000,
            animateGradually: { enabled: true, delay: 1500 },
            dynamicAnimation: { enabled: true, speed: 1500 }
          },
          toolbar: {show: false}
        },
        theme: {
          mode : this.dark ? 'dark' : 'light',
          palette: this.dark ? 'palette_dark' || 'palette7' :
          'palette_light' || 'palette8', 
        },
        fill: {
          type: "gradient",
          gradient: {
            shade: "dark",
            type: "vertical",
            shadeIntensity: 0.5,
            inverseColors: false,
            opacityFrom: 1,
            opacityTo: 0.8,
            stops: [0, 100]
          }
        },
        plotOptions: {
          bar: {
            // distributed: false,
            distributed: this.args.stacked != undefined ? !this.args.stacked : true,
            dataLabels: {
              position: 'top',
            },
            tooltip: {
              fillSeriesColor: false,
              formatter: function (value) {
                return value
              }
            },
          }
        },
        legend: {
          show: this.args.stacked
        },
        tooltip: {
          fillSeriesColor: false,
          custom: this.toolTipFormatter
        },
        dataLabels: {
          formatter: function (value) {
            return value == 0 ? '' : value
          }
        },
        xaxis: this.args.xaxis ?? 
        {
          labels: {
            show: true,
            formatter: this.fullScreen ? this.noTrim : this.shortTrim
          }
        }
      },
      series: [{name: 't', data:[]}],
    }
  },
  computed: {
    dark: sync('misc/dark'),
    fullScreen: sync('fullScreen'),
    cUnit () {
      return this.args.unit == undefined ? '' : ' '+this.args.unit
    }
  },
  methods: {
    shortTrim (val) {
      return val.toString().substring(0,8)
    },
    noTrim (val) {
      return val
    },
    trim (v) {
      if (v == null) return ''
      let ll = 12 
      if (v.length <= ll+3) return v
      var lx = ll - 3
      return this.fullScreen ? v : v.substring(0,8) + '...' + v.slice(-2)
    },
    toolTipFormatter ({series, seriesIndex,dataPointIndex, w}) {
      return (
        '<div class="arrow_box">' + 
        w.globals.labels[dataPointIndex] + "<br/>" +
          + series[seriesIndex][dataPointIndex] + this.cUnit + "</div>"
      )
    }
  },
  beforeMount () { 
  },
  mounted () {
  },
  created () {
  },
  destroyed () {
  }
}
</script>

<style >
.arrow_box {
  border: 2px solid;
  padding: 5px;
}
.echarts {
  width: 100%;
  height: 100%;
}
#bar-chart {
}
</style>